import Vue from "vue";
import Router from "vue-router";
import { Get, WxLogin } from "./utils/Api";
import { Toast } from "vant";

Vue.use(Router);

const routes = [
	//{ path: "/", redirect: "/home" },
	{
		path: "/cabinetDetail",
		name: "cabinetDetail",
		component: () => import("./view/cabinet/detail"),
		meta: {
			title: "书柜详情",
		},
	},
	{
		path: "/register",
		name: "register",
		component: () => import("./view/author/register"),
		meta: {
			title: "用户注册",
		},
	},
	{
		path: "/userRelation",
		name: "userRelation",
		component: () => import("./view/author/userRelation"),
		meta: {
			title: "用户关联",
		},
	},
	{
		path: "/",
		name: "home",
		component: () => import("./view/home"),
		meta: {
			title: "首页",
		},
	},
	{
		path: "/login",
		name: "login",
		component: () => import("./view/author/login"),
		meta: {
			title: "用户登录",
		},
	},
	{
		path: "/user",
		name: "user",
		component: () => import("./view/user"),
		meta: {
			title: "个人中心",
		},
	},
	{
		path: "/wish",
		name: "wish",
		component: () => import("./view/wish"),
		meta: {
			title: "收藏列表",
		},
	},
	{
		path: "/reference",
		name: "reference",
		component: () => import("./view/user/reference"),
		meta: {
			title: "用户使用手册",
		},
	},

	{
		path: "/goods/detail/:id",
		name: "goodsDetail",
		component: () => import("./view/goods/detail"),
		meta: {
			title: "商品详情",
		},
	},
	// {
	// 	path: "/book/detail/:bookId",
	// 	name: "bookDetail",
	// 	component: () => import("./view/book/detail"),
	// 	meta: {
	// 		title: "图书详情",
	// 	},
	// },
	{
		path: "/order/detail/:orderId",
		name: "orderDetail",
		component: () => import("./view/order/detail"),
		meta: {
			title: "图书详情",
		},
	},
];

// add route path
routes.forEach((route) => {
	route.path = route.path || "/" + (route.name || "");
});

const router = new Router({
	mode: "history",
	routes: routes,
});

router.beforeEach((to, from, next) => {
	const title = to.meta && to.meta.title;
	if (title) {
		document.title = title;
	}

	console.log(to.query);

	const code = to.query.code;
	const state = to.query.state;
	var openId = localStorage.getItem("openId");

	console.log("openId", openId);

	if (
		openId != undefined &&
		openId != null &&
		openId != "" &&
		openId != "null"
	) {
		Get(
			"existUserInfo",
			{
				openId: openId,
			},
			(res) => {
				var data = res.data;

				console.log("是否有当前微信用户信息", data);

				if (data.success) {
					Get(
						"hasRegister",
						{
							openId: openId,
						},
						(res) => {
							var data = res.data;

							console.log("用户是否注册", data);

							switch (data.code) {
								case 0:
								case 7:
									next();
									break;
								case 6:
									Toast.fail(data.msg);
									router.push({ name: "register" });
									break;
								case 10:
									Toast.fail(data.msg);
									router.push({ name: "home" });
									break;
							}
						},
						(res) => {
							console.log("ERROR", res);
						}
					);
				} else {
					localStorage.removeItem("openId");
					WxLogin(window.location.href);
				}
			},
			(res) => {
				console.log("ERROR", res);
			}
		);
	} else {
		if (!code && !state) {
			var href = window.location.href;
			WxLogin(href.split("?")[0]);
		} else {
			Get(
				"getUserInfo",
				to.query,
				(res) => {
					var data = res.data;

					if (data.openId != "" && data.openId != undefined) {
						localStorage.setItem("openId", data.openId);
						console.log("获取用户信息", data);
						Get(
							"hasRegister",
							{
								openId: data.openId,
							},
							(res) => {
								var data = res.data;

								console.log("用户是否注册", data);

								switch (data.code) {
									case 0:
									case 7:
										next();
										break;
									case 6:
										router.push({ name: "register" });
										break;
								}
							},
							(res) => {
								console.log("ERROR", res);
							}
						);
					}
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		}
	}

	console.log(router.query);
	console.log(to);
	console.log(from);

	next();
});

export { router };
